<template>
  <div
    class="menuProduit_famille_container"
    :class="`plv_${item.CODE}`"
  >
    <p
      class="menuProduit_famille_titre"
      :class="{'withPicto' : item.OPTIONS && item.OPTIONS.SHOW_PICTO_MENU && item.OPTIONS.PICTO}"
    >
      <a
        :class="levelClass"
        :href="item.LIEN"
        :title="formatLibelle(item.LIBELLE)"
      >
        <img
          v-if="item.OPTIONS && item.OPTIONS.SHOW_PICTO_MENU && item.OPTIONS.PICTO"
          :src="item.OPTIONS.PICTO"
        >
        <span
          v-html="formatLibelle(item.LIBELLE)"
        />
      </a>
    </p>

    <div
      v-if="currentLevel < niveauMax && item.PLAN_VENTE && item.PLAN_VENTE.length > 0"
      class="menuProduit_famille"
    >
      <menu-item
        v-for="child in item.PLAN_VENTE"
        :key="child.CODE"
        :item="child"
        :niveau-max="niveauMax"
        :current-level="currentLevel + 1"
        :plv-casse="plvCasse"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MenuItem', // CRITIQUE : Permet au composant de s'appeler lui-même dans son template
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({ PLAN_VENTE: [], OPTIONS: {} })
    },
    niveauMax: {
      type: Number,
      default: 0
    },
    currentLevel: {
      type: Number,
      default: 1
    },
    plvCasse: {
      type: String,
      default: ''
    }
  },
  computed: {
    // Calcule dynamiquement la classe CSS : menu_niv2, menu_niv3, etc.
    levelClass() {
      return `menu_niv${this.currentLevel + 1}`
    }
  },
  methods: {
    formatLibelle(libelle) {
      if (!libelle) return ''
      if (this.plvCasse === 'maj') return libelle.toUpperCase()
      if (this.plvCasse === 'min') {
        return libelle.charAt(0).toUpperCase() + libelle.slice(1).toLowerCase()
      }
      return libelle
    }
  }
}
</script>
